export default __webpack_public_path__ + "static/media/women.40a56bc6.png";